export default {"src":"/_next/static/media/submit-residence.00c33cff.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};